import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { useDingTalkSubAccountStore } from "../store/dingtalk-subaccount-store";
import { URLSearchParamsHelper } from "project-config/utils/url-search";
import { ChildManagerType } from "@/pages/child-customer/constant";

export function useDingTalkChildManage() {
  const location = useLocation();
  const { t } = useTranslation("childManager");
  const [messageApi, contextHolder] = message.useMessage();
  const { isSyncData, isSyncDataFail, handleSynchronousData, deptInfo, initPageLoading, openSettingModal, setOpenSettingModal, isInitPage } = useDingTalkSubAccountStore();
  const urlSearchParamsHelper = new URLSearchParamsHelper(location.search);
  const activeName = urlSearchParamsHelper.get("activeName");

  useEffect(()=>{
    messageApi.destroy();
    if (activeName === ChildManagerType.childManager || (!isSyncData && !isSyncDataFail)) return
    messageApi.open({
      type: isSyncDataFail ? 'error' : 'loading',
      duration: 0,
      className: 'synchronous-message',
      content: <>
      {!isSyncDataFail && t("dingtalk_subaccount_synchronous_loadingtext")}
      {isSyncDataFail && <div className="synchronous-message-content">{t("dingtalk_subaccount_synchronous_loading_fail")}<span onClick={handleSynchronousData}>{t("dingtalk_subaccount_synchronous_loading_retry")}</span></div>}
      </>,
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSyncData, isSyncDataFail, location])

  return {
    contextHolder,
    deptInfo, 
    initPageLoading, 
    openSettingModal, 
    setOpenSettingModal, 
    isInitPage,
  };
}

